export default "__VITE_ASSET__CTNfxv31__"